import { getIsFreeShipping } from '@cart-services/core/shippingService'
import { type PlatformType } from '@cart-services/hooks/fp-b2b/store-map'
import { useFpB2bCartCalculate } from '@cart-services/hooks/fp-b2b/use-fp-b2b-cart-calculate'
import { useTimeout } from '@dni-react-hooks/use-timeout'
import { Fade } from '@pets-ui/Fade/Fade'
import { HStack } from '@pets-ui/HStack/HStack'
import { Check } from '@pets-ui/icons'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { useEffect, useState } from 'react'

interface ShippingPromoteDescriptionProps {
  campaignId: number
  campaignCode: string
  minShippingAmount?: number
  minShippingFee?: number
  platform: PlatformType
}

export const ShippingPromoteDescription = (props: ShippingPromoteDescriptionProps) => {
  const { campaignId, campaignCode, minShippingAmount, minShippingFee, platform } = props
  const [isShowFreeShippingNotification, setIsShowFreeShippingNotification] = useState(false)
  const { calculateResult } = useFpB2bCartCalculate(campaignId, campaignCode, platform)
  const { shipping_total } = calculateResult || {}
  const isFreeShipping = getIsFreeShipping(minShippingAmount, minShippingFee, shipping_total)
  /** 已達最後門檻但仍有運費 */
  const isShippingDiscount = (minShippingAmount ?? 0) <= 0 && (minShippingFee ?? 0) > 0

  const hasReachedThreshold = isFreeShipping || isShippingDiscount

  useEffect(() => {
    if (hasReachedThreshold) {
      setIsShowFreeShippingNotification(true)
    }
  }, [hasReachedThreshold, minShippingAmount, minShippingFee])

  useTimeout(() => {
    if (isShowFreeShippingNotification) {
      setIsShowFreeShippingNotification(false)
    }
  }, (isShowFreeShippingNotification && isFreeShipping) ? 5000 : null)

  if (typeof minShippingAmount === 'undefined' || typeof minShippingFee === 'undefined' || typeof shipping_total === 'undefined') {
    return null
  }

  if (!hasReachedThreshold) {
    return null
  }

  return (
    <Fade
      in={isShowFreeShippingNotification}
      duration={500}
    >
      <HStack alignItems="center" gap={1}>
        <Check color={colors.green600} />
        <Text color={colors.grey600}>
          {isFreeShipping ? '達免運' : '達運費折扣'}
        </Text>
      </HStack>
    </Fade>
  )
}
